import { render, staticRenderFns } from "./FormElementCheckbox.vue?vue&type=template&id=61cf07bc"
import script from "./FormElementCheckbox.vue?vue&type=script&lang=js"
export * from "./FormElementCheckbox.vue?vue&type=script&lang=js"
import style0 from "./FormElementCheckbox.vue?vue&type=style&index=0&id=61cf07bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports